import { ROUTES } from '@/routes/routeConfig'

export const MTRouteMap: Record<string, string> = {
  // Returns child routes
  define: ROUTES.MT_RETURNS_DEFINE,
  upload: ROUTES.MT_RETURNS_UPLOAD,
  prepare: ROUTES.MT_RETURNS_PREPARE,
  compute: ROUTES.MT_RETURNS_COMPUTE,
  allocate: ROUTES.MT_RETURNS_ALLOCATE,
  returns: ROUTES.MT_RETURNS_RETURNS,
  reports: ROUTES.MT_RETURNS_REPORTS,
  // Sidebar routes
  DASHBOARD: ROUTES.DASHBOARD,
  RETURNS: ROUTES.MT_RETURNS,
  PROVISION_ADVANCE_KNOCKOFF: ROUTES.MT_PROVISION_ADVANCE,
  DOWNLOADS: ROUTES.DOWNLOAD,
  ADMIN: ROUTES.MT_ADMIN,
}
